export { default, ProductsSearchResultSSR } from './ProductsSearchResult';
export type { ProductsSearchResultProps as IProductsSearchResultProps } from './ProductsSearchResult';
